export const pickerStatusKeys = [
  "new",
  "waiting-for-selection",
  "in-selection",
  "selection-completed",
  "view-only",
  "deleted",
  "disabled",
];

const isProd = process.env.REACT_APP_STAGE.trim() === "prod";
const prefix = isProd ? "" : "test-";

export const PICKER_BASE_LINK = `https://${prefix}picker-new.jumbomail.me/`;
export const PICKER_BASE_EDIT_LINK = `https://${prefix}picker-set.jumbomail.me/`;

export const removeSavedStatus = (statuses = []) => {
  if (statuses.length === 0) {
    return statuses;
  }
  return statuses?.filter((status) => status !== "saved") || statuses;
};
